export const LIST_FETCH_BEGIN = "LIST_FETCH_BEGIN";
export const LIST_FETCH_SUCCESS = "LIST_FETCH_SUCCESS";
export const LIST_FETCH_FAILURE = "LIST_FETCH_FAILURE";

export const SELECT_ITEM = "SELECT_ITEM";

export const UPDATE_LIST = "UPDATE_LIST";
